import React from 'react'
import NavButton from '../NavButton/NavButton'
import { useLocation } from 'react-router-dom'

const PORTAL_TABS = [
  { text: 'Dashboard', to: '/portal' },
  { text: 'Activity', to: '/portal/activity' },
]

const PortalNavHeader = () => {
  const location = useLocation()

  const getActiveClass = (path) => {
    const isActive = path === '/portal'
      ? location.pathname === '/portal' || location.pathname === '/'
      : location.pathname === path
    return isActive ? 'border-b-2 border-primary-contrast pb-2 mr-5' : 'pb-2 mr-5'
  }

  return (
    <div className="flex flex-row items-center justify-start bg-primary-main w-full px-5 md:px-10 pt-5 pb-4 overflow-x-auto">
      {PORTAL_TABS.map((tab) => (
        <div key={tab.to} className={getActiveClass(tab.to)}>
          <NavButton text={tab.text} to={tab.to} />
        </div>
      ))}
    </div>
  )
}

export default PortalNavHeader
